/**
 * G21 theme bootstrap + non-routing URL cleanup.
 * Shopify localization, menus and links remain native and authoritative.
 * No theme ID, subdomain or locale route is hard-coded.
 */
(() => {
  'use strict';

  const DISPLAY_ONLY_PARAMS = ['_fd', 'pb'];

  const cleanCurrentAddress = () => {
    try {
      const url = new URL(window.location.href);
      let changed = false;

      DISPLAY_ONLY_PARAMS.forEach((name) => {
        if (url.searchParams.has(name)) {
          url.searchParams.delete(name);
          changed = true;
        }
      });

      if (!changed) return false;

      const next = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState(window.history.state, '', next);
      return true;
    } catch (_error) {
      return false;
    }
  };

  const scheduleAddressCleanup = () => {
    [0, 50, 250, 750, 1500].forEach((delay) => {
      window.setTimeout(cleanCurrentAddress, delay);
    });
  };

  const currentScriptUrl = document.currentScript?.src || '';

  const loadSiblingAsset = (filename, type, marker) => {
    if (!currentScriptUrl) return;
    const url = currentScriptUrl.replace(/g21-theme-enhancements\.js(?=\?|$)/, filename);
    if (!url || url === currentScriptUrl || document.querySelector(`[data-${marker}]`)) return;

    if (type === 'style') {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset[marker] = 'true';
      document.head.appendChild(link);
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    script.defer = true;
    script.dataset[marker] = 'true';
    document.head.appendChild(script);
  };

  loadSiblingAsset('g21-theme-enhancements-core-g21chatgpt.js', 'script', 'g21CoreLoader');
  loadSiblingAsset('matrix-premium-variant-picker.css', 'style', 'matrixPremiumVariantsCss');
  loadSiblingAsset('matrix-premium-variant-picker.js', 'script', 'matrixPremiumVariantsJs');

  window.addEventListener('pageshow', scheduleAddressCleanup);
  window.addEventListener('popstate', scheduleAddressCleanup);
  document.addEventListener('shopify:section:load', scheduleAddressCleanup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAddressCleanup, { once: true });
  } else {
    scheduleAddressCleanup();
  }

  window.G21UrlCleanup = Object.freeze({
    installed: true,
    strips: DISPLAY_ONLY_PARAMS.slice(),
    cleanCurrentAddress
  });
})();
